module.exports = __webpack_public_path__ + "static/media/goBackLeftArrow.2f74481b.svg";